// extracted by mini-css-extract-plugin
export var footerTop = "style-module--footerTop--2e63W";
export var footerLists = "style-module--footerLists--3uaTG";
export var footerRay = "style-module--footerRay--1vr98";
export var footerCardano = "style-module--footerCardano--2dlhA";
export var footerApp = "style-module--footerApp--dAOsv";
export var footerTestnet = "style-module--footerTestnet--7BNEg";
export var footerFaucet = "style-module--footerFaucet--2uWyo";